<template>
    <v-app-bar app color="background" text flat prominent absolute dense style="z-index: 3">
        <app-logo app />
        <app-menu />
        <v-spacer />
        <!-- <app-search /> -->
        <!-- <app-notifications /> -->
        <app-account-switcher />
    </v-app-bar>
</template>

<script>
export default {
    name: 'AppBar',
    components: {
        AppAccountSwitcher: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppAccountSwitcher'
            ),
        AppLogo: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppLogo'
            ),
        AppMenu: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppMenu'
            )
        // AppNotifications: () =>
        //     import(
        //         /* webpackChunkName: "core" */
        //         '@/components/AppNotifications'
        //     ),
        // AppSearch: () =>
        //     import(
        //         /* webpackChunkName: "core" */
        //         '@/components/AppSearch'
        //     )
    }
};
</script>
